/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Apex Team to build your optimal lineup, Budget Boost to spot price risers, and Stats to find the best-value picks for every race weekend.`)
};

const es_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa Equipo Apex para armar tu alineación óptima, Impulso de Presupuesto para detectar subidas de precio, y Estadísticas para encontrar los mejores picks de valor en cada fin de semana de carrera.`)
};

const de_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutze Apex-Team für dein optimales Lineup, Budget Boost für Preisanstiege und Stats für die besten Picks jedes Rennwochenendes.`)
};

const nl_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik Apex Team om je optimale opstelling samen te stellen, Budget Boost om prijsstijgers te spotten en Stats om de best-waarde keuzes te vinden voor elk raceweekend.`)
};

const fr_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez Équipe Apex pour construire votre composition optimale, Boost Budget pour repérer les hausses de prix, et les Stats pour trouver les meilleurs rapports qualité-prix chaque week-end de course.`)
};

const it_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa Team Apex per costruire la formazione ottimale, Budget Boost per individuare i rialzi di prezzo, e Statistiche per trovare le migliori scelte in termini di valore per ogni weekend di gara.`)
};

const pt_br2_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Equipe Apex para montar sua escalação ideal, Impulso de Orçamento para identificar altas de preço, e Estatísticas para encontrar as melhores escolhas de valor para cada fim de semana de corrida.`)
};

const pt_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a Equipa Apex para construir o alinhamento ideal, o Impulso de Orçamento para detetar subidas de preço e as Estatísticas para encontrar as melhores escolhas de valor para cada fim de semana de corrida.`)
};

const ja_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apexチームで最適なラインナップを構築、バジェットブーストで価格上昇を見つけ、統計で毎レースウィークエンドのベストバリューピックを発見。`)
};

const zh_f1_home_tools_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用Apex团队组建最优阵容，使用预算助推发现涨价车手，使用统计数据为每个比赛周找到最佳性价比选择。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_tools_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_tools_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_tools_description", locale)
	if (locale === "en") return en_f1_home_tools_description(inputs)
	if (locale === "es") return es_f1_home_tools_description(inputs)
	if (locale === "de") return de_f1_home_tools_description(inputs)
	if (locale === "nl") return nl_f1_home_tools_description(inputs)
	if (locale === "fr") return fr_f1_home_tools_description(inputs)
	if (locale === "it") return it_f1_home_tools_description(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_tools_description(inputs)
	if (locale === "pt") return pt_f1_home_tools_description(inputs)
	if (locale === "ja") return ja_f1_home_tools_description(inputs)
	return zh_f1_home_tools_description(inputs)
};